export default __webpack_public_path__ + "static/media/cisoadvisor.fe9c60eb.svg";